import { Result, failure, success } from '../shared'
import { UserConfigProvider } from './userConfig.provider'
import { UserOperProvider } from './userOper.provider'
import {
  UserConfigServiceErrorCode,
  UserConfigServerData,
  PasswordRulesServerData,
  ChangePasswordFailure,
  ConfigItem,
} from './userConfig.types'

export class UserConfigService {
  constructor(private configProvider: UserConfigProvider, private operProvider: UserOperProvider) {}

  public async get(): Promise<Result<UserConfigServerData>> {
    try {
      const { data } = await this.configProvider.get()
      return success(data)
    } catch (error) {
      return failure(UserConfigServiceErrorCode.GENERAL)
    }
  }

  public async set(key: ConfigItem, value: string | number): Promise<Result<unknown>> {
    try {
      const { data } = await this.configProvider.set(key, value)
      return success(data)
    } catch (error) {
      return failure(UserConfigServiceErrorCode.GENERAL)
    }
  }

  public async refresh(): Promise<Result<unknown>> {
    try {
      const { data } = await this.configProvider.refresh()
      return success(data)
    } catch (error) {
      return failure(UserConfigServiceErrorCode.GENERAL)
    }
  }

  public async getPasswordRules(userID: number, hash?: string): Promise<Result<PasswordRulesServerData>> {
    try {
      const { data } = await this.operProvider.getPasswordRules(userID, hash)
      return success(data)
    } catch (error) {
      return failure(UserConfigServiceErrorCode.GENERAL)
    }
  }

  public async changePassword(
    userID: number,
    password: string | undefined,
    newPassword: string,
    hash?: string,
  ): Promise<Result<void, ChangePasswordFailure>> {
    try {
      await this.operProvider.changePassword(userID, password, newPassword, hash)
      return success()
    } catch (error) {
      const errorCode: string = error.Message || error.Text

      const code =
        errorCode === 'ERR_INVALID_OLDPASS'
          ? UserConfigServiceErrorCode.INVALID_OLD_PASSWORD
          : UserConfigServiceErrorCode.GENERAL

      return failure(code, { message: errorCode })
    }
  }
}
